import { Button, Stack } from '@workramp/ui';
import styled from 'styled-components';

export const ResultTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${({ theme }) => `${theme.spacing(2)}px`};
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  width: ${({ theme }) => `${theme.spacing(4)}px`};
`;

export const ResultBodyStack = styled(Stack)`
  max-width: 1024px;
  padding-left: ${({ theme }) => `${theme.spacing(6)}px`};
`;

export const ShowButton = styled(Button)`
  padding-left: ${({ theme }) => `${theme.spacing(6)}px`};
`;
